"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = function (str) { return str == null || str.length === 0; };
//# sourceMappingURL=str.js.map